import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowIcon } from '../../img/cpay-svg/arrow-back.svg';
import { ReactComponent as ArrowIconNFG } from '../../img/nfgpay-svg/arrow-back-nfg.svg';
import { ReactComponent as ArrowIconFinvaro } from '../../img/finvaro/arrow-back-finvaro.svg';
import { ReactComponent as ArrowIconClarnium } from '../../img/clarnium/arrow-back-clarnium.svg';
import { ReactComponent as ArrowIconInex } from '../../img/inex/arrow-back-inex.svg';
import { ReactComponent as ArrowIconInsta } from '../../img/instaXchange/arrow-back-insta.svg';
import { ReactComponent as ArrowIconCoinera } from '../../img/coinera/arrow-back-coinera.svg';
import LoginForm from '../LoginForm/LoginForm';
import LoginPhoneForm from '../LoginPhoneForm';
import LoginSocialMedia from '../LoginSocialMedia';
import './style.scss';
import { identity } from '../../utils/getIdentity';


const copyIcon = {
  cpay: <ArrowIcon />,
  nfg: <ArrowIconNFG />,
  finvaro: <ArrowIconFinvaro />,
  clarnium: <ArrowIconClarnium />,
  inex: <ArrowIconInex />,
  insta: <ArrowIconInsta />,
  coinera: <ArrowIconCoinera />
};

const LoginOptions = () => {
  const [loginOption, setLoginOption] = useState(0);
  const [userType, setUserType] = useState('corporate');
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('inex');

  const agent = identity === 'inex' ? activeTab : undefined;

  return (
    <>
      {loginOption === 0 ? (
        <div className={`login-form login-form-${identity} login-options`}>
          {identity !== 'finvaro' && <span className={`login-options__title login-options__title-${identity}`}>{t('auth.signUpOrLogIn')}</span>}
          {/*{identity === 'inex' && (
            <div className="login-options__tabs">
              <div
                className={`login-options__tab ${activeTab === "inex" && "login-options__tab--active"}`}
                onClick={() => setActiveTab("inex")}
              >
                INEX
              </div>
              <div
                className={`login-options__tab ${activeTab === "panther" && "login-options__tab--active"}`}
                onClick={() => setActiveTab("panther")}
              >
                Panther
              </div>
            </div>
          )}*/}
          <div className="login-options__items">
            <div className={`login-options__item login-options__item-${identity}`} onClick={() => setLoginOption(1)}>
              <span>{t("auth.continueWithEmail")}</span>
              {copyIcon[identity]}
            </div>
            <div className={`login-options__item login-options__item-${identity}`} onClick={() => setLoginOption(2)}>
              <span>{t("auth.continueWithPhone")}</span>
              {copyIcon[identity]}
            </div>

            {identity !== 'finvaro' && (
              <div className="login-options__divider">{t('text.or')}</div>
            )}
            {identity !== 'finvaro' && (
              <LoginSocialMedia userType={userType} />
            )}
          </div>

          {identity !== 'finvaro' && (
            <div className={`login-form__text login-form__text_center login-form__text-${identity}`}>
              {t('auth.dontHaveAccount')} <Link to="/sign-up">{t('signUp')}!</Link>
            </div>
          )}
        </div>
      ) : loginOption === 1 ? (
        <LoginForm agent={agent} backAction={() => setLoginOption(0)} />
      ) : (
        <LoginPhoneForm agent={agent} backAction={() => setLoginOption(0)} />
      )}
    </>
  );
};

export default LoginOptions;
